import React, { useState } from "react"
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Input,
  Label,
} from "reactstrap"
import Breadcrumb from "components/Common/Breadcrumb"
import Loader from "components/Loader/loader"
import {
  FaUser,
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt,
  FaHome,
  FaCamera,
  FaTrash,
} from "react-icons/fa"
import ProfileImage from "../../assets/images/profile-img.png"
import secureLocalStorage from "react-secure-storage"
import Swal from "sweetalert2"
import { FetchPutData } from "utils/Common_api_functions"

const ProfilePage = () => {
  const [loading, setLoading] = useState(false)
  const [profile, setProfile] = useState(
    secureLocalStorage?.getItem("admin_user")
  )
  const [form, setForm] = useState({ ...profile })

  const handleSave = async () => {
    const APIdata = await FetchPutData(setLoading, `employee`, form.id, form)
    if (APIdata?.data?.success) {
      Swal.fire({
        title: "Profile Updated Successfully.",
        icon: "success",
      })
      secureLocalStorage?.setItem("admin_user", APIdata?.data?.employee)
    } else {
      Swal.fire({
        title: "Something Went Wrong",
        text: APIdata?.response?.data?.message,
        icon: "error",
      })
    }
  }

  const handleChange = (field, value) => {
    setForm({ ...form, [field]: value })
  }

  const handleImageUpload = e => {
    const file = e.target.files[0]
    if (file) {
      const reader = new FileReader()
      reader.onloadend = () => {
        setForm({ ...form, profilePicture: reader.result })
      }
      reader.readAsDataURL(file)
    }
  }

  const handleRemoveImage = () => {
    setForm({ ...form, profilePicture: null })
  }

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumb
          title="Dashboard"
          breadcrumbItem="Profile"
          description="View and update your personal details."
        />

        {loading && <Loader />}

        <Row>
          {/* Form Section */}
          <Col lg="12" className="px-0">
            <Card className="shadow-lg border-0">
              <CardBody>
                {/* Header */}
                <div
                  className="d-flex justify-content-between align-items-center p-3 mb-4 rounded-4"
                  style={{
                    background: "linear-gradient(to right, #2563eb, #4f46e5)",
                    color: "white",
                  }}
                >
                  <div className="d-flex align-items-center">
                    <div className="position-relative me-3">
                      <div
                        className="bg-white d-flex justify-content-center align-items-center shadow"
                        style={{
                          width: "90px",
                          height: "90px",
                          borderRadius: "50%",
                          overflow: "hidden",
                        }}
                      >
                        {form.profilePicture ? (
                          <img
                            src={form.profilePicture}
                            alt="Profile"
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                          />
                        ) : (
                          <FaUser size={40} color="#4f46e5" />
                        )}
                      </div>

                      <div
                        className="position-absolute"
                        style={{ bottom: "-5px", right: "-5px" }}
                      >
                        <input
                          type="file"
                          id="profile-upload"
                          accept="image/*"
                          onChange={handleImageUpload}
                          style={{ display: "none" }}
                        />
                        <label
                          htmlFor="profile-upload"
                          className="d-flex justify-content-center align-items-center bg-white border shadow-sm"
                          style={{
                            width: "30px",
                            height: "30px",
                            borderRadius: "50%",
                            cursor: "pointer",
                          }}
                        >
                          <FaCamera color="#4f46e5" size={14} />
                        </label>
                      </div>
                    </div>

                    <div>
                      <h4 className="fw-bold mb-0">My Profile</h4>
                      <small className="text-light">
                        Manage your personal information
                      </small>
                    </div>
                  </div>

                  {form.profilePicture && (
                    <Button color="danger" onClick={handleRemoveImage}>
                      <FaTrash className="me-2" /> Remove Photo
                    </Button>
                  )}
                </div>

                {/* Editable Fields */}
                <div className="px-2">
                  <Row className="mb-3">
                    <Col md="6">
                      <Label className="fw-semibold">Name</Label>
                      <Input
                        value={form.name}
                        onChange={e => handleChange("name", e.target.value)}
                      />
                    </Col>

                    <Col md="6">
                      <Label className="fw-semibold">Email</Label>
                      <Input
                        value={form.email}
                        onChange={e => handleChange("email", e.target.value)}
                        disabled
                      />
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col md="6">
                      <Label className="fw-semibold">Phone</Label>
                      <Input
                        type="text"
                        name="phone"
                        value={
                          form?.phone
                            ? form.phone.startsWith("+44")
                              ? form.phone
                              : `+44 ${form.phone}`
                            : "+44 "
                        }
                        onChange={e => {
                          let inputValue = e.target.value.replace(/\D/g, "") // keep only digits
                          if (inputValue.startsWith("44"))
                            inputValue = inputValue.slice(2) // avoid double +44
                          if (inputValue.startsWith("0"))
                            inputValue = inputValue.slice(1)
                          handleChange("phone", inputValue)
                        }}
                        maxLength="13"
                        placeholder="+44 XXXXXXXXXX"
                      />
                    </Col>

                    <Col md="6">
                      <Label className="fw-semibold">Date of Birth</Label>
                      <Input
                        type="date"
                        value={form.dob}
                        onChange={e => handleChange("dob", e.target.value)}
                      />
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col md="6">
                      <Label className="fw-semibold">Address 1</Label>
                      <Input
                        value={form.address1}
                        onChange={e => handleChange("address1", e.target.value)}
                      />
                    </Col>

                    <Col md="6">
                      <Label className="fw-semibold">Address 2</Label>
                      <Input
                        value={form.address2}
                        onChange={e => handleChange("address2", e.target.value)}
                      />
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col md="6">
                      <Label className="fw-semibold">Town / City</Label>
                      <Input
                        value={form.city}
                        onChange={e => handleChange("city", e.target.value)}
                      />
                    </Col>

                    <Col md="6">
                      <Label className="fw-semibold">Country</Label>
                      <Input
                        value={form.country}
                        onChange={e => handleChange("country", e.target.value)}
                      />
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col md="6">
                      <Label className="fw-semibold">Postcode</Label>
                      <Input
                        value={form.postcode}
                        onChange={e => handleChange("postcode", e.target.value)}
                      />
                    </Col>

                    <Col md="6">
                      <Label className="fw-semibold">NI Number</Label>
                      <Input
                        value={form.nationalInsuranceNumber}
                        onChange={e => handleChange("nationalInsuranceNumber", e.target.value)}
                      />
                    </Col>
                  </Row>

                  {/* Bank Details */}
                  <h5 className="fw-bold mt-4 mb-3">Bank Details</h5>

                  <Row className="mb-3">
                    <Col md="6">
                      <Label className="fw-semibold">Sort Code</Label>
                      <Input
                        value={form.sortCode}
                        onChange={e => handleChange("sortCode", e.target.value)}
                      />
                    </Col>

                    <Col md="6">
                      <Label className="fw-semibold">Account Number</Label>
                      <Input
                        value={form.bankAccountNumber}
                        onChange={e =>
                          handleChange("bankAccountNumber", e.target.value)
                        }
                      />
                    </Col>
                  </Row>

                  {/* Save Button */}
                  <div className="d-flex justify-content-start mt-4">
                    <Button
                      color="primary"
                      className="rounded-4 fs-5"
                      onClick={handleSave}
                    >
                      Save Profile
                    </Button>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default ProfilePage
